import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactMapGL, { Marker, ScaleControl, NavigationControl, FlyToInterpolator } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Pin from './pin';

const mapViewStyle = {
  street: 'mapbox://styles/mapbox/streets-v11',
  satellite: 'mapbox://styles/mapbox/satellite-streets-v11',
};

const Mapbox = props => {
  const { latitude, longitude, zoomLevel, height, width, markerDragEndHandler, collapseSearchFieldHandler } = props;
  const [viewport, setViewport] = useState({
    latitude: latitude,
    longitude: longitude,
    zoom: zoomLevel,
    bearing: 0,
    pitch: 0,
    transitionDuration: 5000,
    transitionInterpolator: new FlyToInterpolator(),
  });

  const [isStreetView, setIsStreetView] = useState(true);
  const [isTransitionEnd, setIsTransitionEnd] = useState(false);
  const [isTransitionStart, SetIsTransitionStart] = useState(false);

  useEffect(() => {
    setViewport(prevState => ({ ...prevState, latitude: latitude, longitude: longitude }));
  }, [latitude, longitude]);

  const onViewPort = viewPort => {
    setViewport(viewPort);
  };

  //Hide the search list if your change the view
  //Discard the view change during transistion
  const viewStateChange = () => {
    if (isTransitionStart) {
      if (isTransitionEnd) {
        collapseSearchFieldHandler();
      }
    } else {
      collapseSearchFieldHandler();
    }
  };

  return (
    <>
      <div className="mapbox-container__viewtoggle-container">
        <div
          className={`mapbox-container__view-btn ${
            isStreetView ? 'mapbox-container__view-btn--satellite' : 'mapbox-container__view-btn--street'
          } `}
          onClick={() => setIsStreetView(!isStreetView)}
        ></div>
      </div>
      <ReactMapGL
        mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_KEY}
        height={height}
        width={width || '100%'}
        {...viewport}
        onViewportChange={onViewPort}
        mapStyle={isStreetView ? mapViewStyle.street : mapViewStyle.satellite}
        onNativeClick={collapseSearchFieldHandler}
        onTransitionStart={() => SetIsTransitionStart(true)}
        onTransitionEnd={() => setIsTransitionEnd(true)}
        onTransitionInterrupt={() => setIsTransitionEnd(true)}
        onViewStateChange={viewStateChange}
      >
        <Marker
          latitude={latitude}
          longitude={longitude}
          offsetTop={-37}
          offsetLeft={-10.5}
          draggable={true}
          onDragEnd={markerDragEndHandler}
        >
          <Pin size={20} />
        </Marker>
        <div className="mapbox-container__navigation">
          <NavigationControl />
        </div>
        <div className="mapbox-container__zoom-control">
          <ScaleControl />
        </div>
      </ReactMapGL>
    </>
  );
};

Mapbox.propTypes = {
  markerDragEndHandler: PropTypes.func.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  zoomLevel: PropTypes.number,
  collapseSearchFieldHandler: PropTypes.func,
};
Mapbox.defaultProps = {
  zoomLevel: 8,
  collapseSearchFieldHandler: () => {},
};

export default Mapbox;
